import axiosCall from './interceptor';
import URL from '../helper';

export const getChannels = async (sourceId, sourceType) => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/map?id=${sourceId}&type=${sourceType}`;
  let response = await axiosCall('get', url);
  return response.data.data;
};

export const getConsolidateVariableContract = async (payload, envType) => {
  const isProdEnv = ['sandbox', 'live'].includes(envType);

  const baseUrl = isProdEnv
    ? `${URL.TRANSACTION_SYSTEM_URL}${envType}/consolidateVariableContract`
    : `${URL.DESIGN_SYSTEM_URL}dynamic/${envType}/fetchVariableContract`;

  try {
    const { data } = await axiosCall('get', baseUrl, payload);
    return data;
  } catch (error) {
    console.error(`Error fetching variable contract for ${envType}:`, error);
    return null;
  }
};

export const getCommunicationsByName = async params => {
  let queryParams = {};
  if (typeof params === 'string') {
    queryParams.name = params;
  } else {
    queryParams = { ...params };
  }
  const searchParams = new URLSearchParams(queryParams);
  const url = `${URL.DESIGN_SYSTEM_URL}channel?${searchParams.toString()}`;
  const response = await axiosCall('get', url);
  return response.data;
};
